var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmartscalar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.19 3.705a.75.75 0 0 0-.896-.426l-3.5 1a.75.75 0 0 0 .412 1.442l1.86-.531L9.15 9.024l-3.845-1.71a.75.75 0 0 0-.874.198l-3 3.5a.75.75 0 1 0 1.138.976l2.637-3.076 3.99 1.773a.75.75 0 0 0 .975-.35l2.277-4.553.863 2.013a.75.75 0 0 0 1.379-.59z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmartscalar);
export default ForwardRef;